import React from "react";

import "../scss/Elements/_tables.scss";
import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { ClientContactsTableAxios } from "../components/Tables/ContactsTable";

function Contacts() {
  const { titleContactsString } = useTranslationHook();

  return (
    <div className="table-module-container">
      <Helmet>
        <title>{titleContactsString}</title>
      </Helmet>
      <div className="datatable">
        <ClientContactsTableAxios />
      </div>
    </div>
  );
}

export default Contacts;
